// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"58febd66","732":"25755591","916":"961df6b1"}[chunkId] + ".chunk.js";
};